/*!
 * csvText.js — a .csv as text() items: a row an item
 * © 2026 Rob Canning — GPLv3
 *
 *     text(cycle:"names.csv", trig:beat.div(4))          the first column, a row a 16th
 *     text(cycle:"names.csv", col:age)                 another column, by name or number
 *     text(cycle:"names.csv", format:"{name}, {age}")  several in a line
 *     header:0                                         the first row is not names
 *
 * Pure (text.js fetches the file).
 */

/** CSV text -> rows of fields: commas, "quoted, fields", "" for a quote, CRLF. */
export function parseCsv(text) {
  const rows = [];
  let row = [], field = "", quoted = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (quoted) {
      if (c === '"' && text[i + 1] === '"') { field += '"'; i++; }
      else if (c === '"') quoted = false;
      else field += c;
    } else if (c === '"' && field === "") quoted = true;
    else if (c === ",") { row.push(field); field = ""; }
    else if (c === "\n" || c === "\r") {
      if (c === "\r" && text[i + 1] === "\n") i++;
      row.push(field); field = "";
      if (row.some(f => f.trim())) rows.push(row);
      row = [];
    } else field += c;
  }
  row.push(field);
  if (row.some(f => f.trim())) rows.push(row);
  return rows.map(r => r.map(f => f.trim()));
}

/**
 * A .csv's rows as items. The first row names the columns (header:0 when it
 * does not); col: which to show -- its name or number (1 the first),
 * default the first -- or format:"{name}, {age}" any of them in a line.
 */
export function csvItems(text, { col = null, format = null, header = true } = {}) {
  const rows = parseCsv(text);
  const names = header && rows.length ? rows.shift().map(h => h.toLowerCase()) : [];
  const at = (key) => {
    const n = Number(key);
    if (Number.isInteger(n) && n >= 1) return n - 1;
    const i = names.indexOf(String(key).toLowerCase());
    return i >= 0 ? i : null;
  };
  const colIndex = col != null ? at(col) ?? 0 : 0;
  return rows.map(r => {
    const text = format != null
      ? String(format).replace(/\{([^}]+)\}/g, (m, key) => { const i = at(key.trim()); return i == null ? m : (r[i] ?? ""); })
      : (r[colIndex] ?? "");
    return { text, dur: null };
  }).filter(it => it.text.trim());
}
